import * as stylex from "@stylexjs/stylex";

import { colors } from "../../../styles/tokens.stylex";

const variants = stylex.create({
    darkBlue: {
        fill: colors.bg_BrandPrimary,
    },
    magenta: {
        fill: colors.b_BrandMagenta,
    },
    white: {
        fill: colors.b_Emphasis,
    },
    gray: {
        fill: colors.gray,
    },
});

export type Variants = keyof typeof variants;

export const useSvgVariant = (variant: Variants) => ({
    fill: variants[variant],
});
